/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PageMetadata } from './page-metadata';
import { TransazioneVoucherBackofficeListItemDTO } from './transazione-voucher-backoffice-list-item-dto';


export interface PagedModelTransazioneVoucherBackofficeListItemDTO { 
    content?: Array<TransazioneVoucherBackofficeListItemDTO>;
    page?: PageMetadata;
}

